//------------------------------------------------------ externos
import { useState } from "react";
//------------------------------------------------------ elementos
//------------------------------------------------------ funciones
import Button from "../../buttons/Button";
import FormProveedor from "../../formularios/FormProveedor";

const MovimientoEmpresaAccess = () => {
  const TITLE = "PROVEEDOR";
  const [formVisible, setFormVisible] = useState(false);

  const handleOpen = () => {
    setFormVisible(true);
  };

  const handleClose = () => {
    setFormVisible(false);
  };

  return (
    <>
      <Button text={TITLE} onClick={handleOpen} icono="proveedor" plus={true} />

      {formVisible && (
        <FormProveedor onGuardar={handleClose} onClose={handleClose} />
      )}
    </>
  );
};

export default MovimientoEmpresaAccess;
